import React, { useEffect } from 'react';
import {DEFAULT_LANG} from "../../utils/seo/utils";
import {useRecoilState} from "recoil";
import {interfaceLangAtom} from "../../store/appStore";

const SEOContent = ({ title, description, keywords, h1Text, image, alt, canonicalUrl }) => {
    const [interfaceLang, ] = useRecoilState(interfaceLangAtom);
    useEffect(() => {
        if (!title) {
            return;
        }

        if (title.length > 60) {
            title = title.substring(0, 60) + "...";
        }

        // update title
        document.title = title;

        // update meta tag
        const updateMeta = (name, content) => {
            let metaTag = document.querySelector(`meta[name="${name}"]`);
            if (!metaTag) {
                metaTag = document.createElement('meta');
                metaTag.name = name;
                document.head.appendChild(metaTag);
            }
            metaTag.content = content;
        };

        const updatePropertyMeta = (property, content) => {
            let metaTag = document.querySelector(`meta[property="${property}"]`);
            if (!metaTag) {
                metaTag = document.createElement('meta');
                metaTag.setAttribute('property', property);
                document.head.appendChild(metaTag);
            }
            metaTag.content = content;
        };

        const updateCanonical = (url) => {
            if (!url) {
                const currentUrl = new URL(window.location.href);
                currentUrl.search = "";
                url = currentUrl.toString();
            }

            const canonicalUrl = new URL(url, window.location.origin);

            if (interfaceLang !== DEFAULT_LANG && interfaceLang !== null) {
                console.log(interfaceLang)
                canonicalUrl.searchParams.set('lang', interfaceLang);
            } else {
                canonicalUrl.searchParams.delete('lang');
            }

            let linkTag = document.querySelector('link[rel="canonical"]');
            if (!linkTag) {
                linkTag = document.createElement('link');
                linkTag.rel = 'canonical';
                document.head.appendChild(linkTag);
            }

            linkTag.href = canonicalUrl.toString();
            return canonicalUrl.toString();
        };

        if (description.length > 160) {
            description = description.substring(0, 157) + "...";
        }

        // update meta description
        updateMeta('description', description);
        updateMeta('keywords', keywords);

        canonicalUrl = updateCanonical(canonicalUrl);

        updatePropertyMeta('og:title', title);
        updatePropertyMeta('og:url', canonicalUrl);
        updatePropertyMeta('og:type', 'website');
        updatePropertyMeta('og:site_name', 'Hyper3D');
        updatePropertyMeta('og:description', description);
        updatePropertyMeta('og:image', image || 'https://hyper3d.ai/assets/og-banner.png');
        if (alt) {
            updatePropertyMeta('og:image:alt', alt);
        }

        return () => {

        };
    }, [title, description, keywords, image, alt, canonicalUrl]);

    return (
        <>
            <h1 style={{ position: 'absolute', left: '-9999px' }}>{h1Text}</h1>
            {image && <img src={image} alt={alt || ''} style={{ display: 'none' }} />}
        </>
    );
};

export default SEOContent;
